// extracted by mini-css-extract-plugin
module.exports = {"heading":"ExpertSectionHeading_heading__lF0u0","icon":"ExpertSectionHeading_icon__QZLMM"};